/**
 * Illustrations and annotations for the District Page.
 */

import * as React from "react";

import {BackgroundBlob} from "#marketing-content-shared-package/background-blob.tsx";
import IllustrationContext from "#marketing-content-shared-package/illustration-context.ts";
import {MediaScrollButton} from "#marketing-content-shared-package/media-scroll-button.tsx";

import EqualizeAccessCollage from "./collages/equalize-access.tsx";
import EveryChildCollage from "./collages/every-child.tsx";
import EveryClassroomCollage from "./collages/every-classroom.tsx";
import LevelPlayingFieldCollage from "./collages/level-playing-field.tsx";
import WorldCollage from "./collages/world.tsx";
import {AnnualReportIcon, LeadershipIcon, PartnerIcon} from "./icons/icons.ts";

type Props = {
    children: React.ReactNode;
};

const Placeholder = () => <div />;

export default class Media extends React.Component<Props> {
    render(): React.ReactNode {
        const {children} = this.props;

        return (
            <IllustrationContext.Provider
                value={{
                    BackgroundBlob,
                    ScrollButton: MediaScrollButton,
                    Placeholder,
                    AnnualReportIcon,
                    LeadershipIcon,
                    PartnerIcon,
                    WorldCollage,
                    EqualizeAccessCollage,
                    EveryClassroomCollage,
                    EveryChildCollage,
                    LevelPlayingFieldCollage,
                }}
            >
                {children}
            </IllustrationContext.Provider>
        );
    }
}
